import { render, staticRenderFns } from "./CriticaDespesaManage.vue?vue&type=template&id=3f3c9f0d&scoped=true"
import script from "./CriticaDespesaManage.vue?vue&type=script&lang=js"
export * from "./CriticaDespesaManage.vue?vue&type=script&lang=js"
import style0 from "./CriticaDespesaManage.vue?vue&type=style&index=0&id=3f3c9f0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c9f0d",
  null
  
)

export default component.exports